import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";

// context
import { useSiteHeader } from "core/SiteHeader/context/useSiteHeader.js";

// components
import Avatar from "core/Avatar";
import Bell from "core/ReusableIcons/Bell";

// data
import { trackheaderBellClicked } from "core/trackEvent";

// styles
import { convertPxToRem } from "frontend/components/helpers";
import colors from "core/colors";
import { easingSeconds } from "core/animation";

const AvatarWithBellStyled = styled.div`
    position: relative;
`;
const BellWrapperStyled = styled.div`
    position: absolute;
    left: ${convertPxToRem(-6)};
    top: ${convertPxToRem(-6)};
    z-index: 1;

    background-color: ${({ $isDarkMode }) =>
        $isDarkMode ? colors.secondary.orca : colors.primary.snow};
    width: ${convertPxToRem(24)};
    height: ${convertPxToRem(24)};
    border-radius: 50%;

    display: flex;
    justify-content: center;
    align-items: center;
`;

const AvatarStyled = styled(Avatar)`
    transition: opacity ${easingSeconds} ease-in-out;

    &:hover {
        opacity: 0.6;
    }
`;

// component
export const AvatarWithBell = ({ className, size = 40 }) => {
    const {
        isDarkMode,
        marketingMessage: { hideBell, html },
        currentUser
    } = useSiteHeader();

    const showBell = !hideBell && html;

    const onMouseDown = () => {
        if (showBell) trackheaderBellClicked();
    };

    return (
        <AvatarWithBellStyled className={className} onMouseDown={onMouseDown}>
            {showBell && (
                <BellWrapperStyled
                    $isDarkMode={isDarkMode}
                    data-testid="avatar-has-bell"
                >
                    <Bell
                        fillColor={colors.functional.lightMode.gladiola}
                        size={{ width: 16, height: 16 }}
                    />
                </BellWrapperStyled>
            )}
            <AvatarStyled user={currentUser} size={size} />
        </AvatarWithBellStyled>
    );
};

export default AvatarWithBell;

// prop-types
AvatarWithBell.propTypes = {
    size: PropTypes.number,
    className: PropTypes.string
};
